
import ChampionTrophy from '../icons/ChampionTrophy.vue';
import { buildAssetUri } from '~/utils/mixins';

export default {
  name: 'LeagueImg',
  components: {
    ChampionTrophy,
  },
  mixins: [buildAssetUri],
  props: {
    src: {
      default: '',
      type: String,
    },
    // The default size is 40px, but if this is called with different sizes than the default while expecting trophy to be displayed, can lead to unexpected UI issues
    // TODO from Julien: Revise that size notion against current needs
    size: {
      default: 40,
      type: Number,
    },
  },
};
